import styled from 'styled-components';
import { easeOutCubic, animationDuration } from '../constants';
import type { TransitionStatus } from 'react-transition-group';

interface Props {
  zIndex: number;
  transitionStatus: TransitionStatus;
}

export const StyledBackground = styled('div')<Props>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.black};
  z-index: ${({ zIndex }) => zIndex};
  /* Default */
  opacity: 0;
  transition: opacity ${animationDuration / 1000}s ${easeOutCubic};
  /* Transitions */
  ${({ transitionStatus }) => {
    if (transitionStatus === 'entered' || transitionStatus === 'entering') {
      return 'opacity: 0.8;';
    }
  }}
`;

export const StyledAccessibleButton = styled('button')`
  display: block;
  margin: 0px;
  padding: 0px;
  appearance: none;
  background: transparent;
  border: 0px;
  line-height: 1;
  outline: 0px;
`;
